import React from 'react';
import styles from './FilterSection.module.scss';
import { BodySectionContainer, Button } from 'components/common';

const FilterSection = ({
  title, options, selectedOptions, setSelected
}) => {
  const areAllSelected = options.length === selectedOptions.length;
  const selectAll = () => {
    areAllSelected
      ? setSelected([])
      : setSelected([...options]);
  };

  return (
    <BodySectionContainer title={title} className={styles.container}>
      <Button className={styles.optionButton} onClick={selectAll}>
        {areAllSelected ? 'Select None' : 'Select All'}
      </Button>
      {options.map((option, index) => {
        const isSelected = selectedOptions.includes(option);
        const bttnStyles = [styles.optionButton];
        isSelected && bttnStyles.push(styles.optionSelected);

        return (
          <Button
            key={index}
            className={bttnStyles.join(' ')}
            onClick={() => {
              let newSelectedOptions = [...selectedOptions];
              if (isSelected) {
                newSelectedOptions = newSelectedOptions.filter(opt => opt !== option);
              } else {
                newSelectedOptions.push(option);
              }
              setSelected(newSelectedOptions);
            }}
          >
            {option.toLowerCase()}
          </Button>
        );
      })}
    </BodySectionContainer>
  );
};

export default FilterSection;
